import { render } from "./DecorationLibraryArtworkDetail.vue?vue&type=template&id=cf7253ee&scoped=true"
import script from "./DecorationLibraryArtworkDetail.vue?vue&type=script&lang=js"
export * from "./DecorationLibraryArtworkDetail.vue?vue&type=script&lang=js"

import "./DecorationLibraryArtworkDetail.vue?vue&type=style&index=0&id=cf7253ee&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cf7253ee"]])

export default __exports__